import { createReducer, on } from "@ngrx/store";
import { findVariableCatalogAct, loadVariableCatalogByIdAct, resetVariableCatalogAct, saveSuccessVariableCatalogAct, setViolationsVariableCatalogAct, showMsgErrorAct, updateSuccessVariableCatalogAct } from "./variable-catalog.action";
import { Variable } from "../../models/formulas/variable";


const variable: Variable = new Variable();

export const VariableCatalogReducer = createReducer (
    {
        variable,
        violations: {},
        loading: true 
    },
    on(resetVariableCatalogAct, (state) => ({
        variable:  { ...variable },
        violations: {},
        loading: state.loading
    })),
    on(findVariableCatalogAct, (state, { id }) =>({
        variable: { ...variable}, 
        violations: state.violations,
        loading: true
    })),
    on(loadVariableCatalogByIdAct, (state, { variable }) =>({
        variable: { ...variable}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessVariableCatalogAct, (state, { variableNew }) => ({
        variable: { ...variableNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessVariableCatalogAct, (state, { variableUpdated }) => ({
        variable: { ...variableUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsVariableCatalogAct, (state, { variableForm, violations }) => ({
        variable: { ...variableForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        variable: state.variable,
        violations: {},
        loading: false
    }))
)